"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerRowSplitScopeActions = exports.createRowSplitScopeActions = exports.saveChangesAndProceed = void 0;
var bulletSplit_1 = require("../bulletSplit");
function saveChangesAndProceed(host, row, proceed) {
    if (row.edit) {
        host.updateRowArray(row, proceed);
    }
    else {
        proceed();
    }
}
exports.saveChangesAndProceed = saveChangesAndProceed;
function finalizeSplit(host, row, context) {
    try {
        row.edit = null;
    }
    catch (_a) { }
    try {
        if (context === 'search')
            host.reloadSearch();
        else if (context === 'recent') {
            host.fetchRecent();
            host.reloadFocus();
        }
        else if (context === 'focus')
            host.reloadFocus();
    }
    catch (_b) { }
}
function handleStandardSplitResponse(host, data, successLabel, noneLabel) {
    if (data.Result === 'OK') {
        host.toast("".concat(successLabel, " created ").concat(data.Count || 0, " note(s)."), 'success', 4500);
    }
    else if (data.Result === 'NONE') {
        host.toast(noneLabel, 'info', 3000);
    }
    else {
        host.toast("Split failed: ".concat(data.Message || data.Result || 'Error'), 'danger', 5000);
    }
}
function createRowSplitScopeActions(host, splitService) {
    function splitByBlankLines(row, keepFirst, context) {
        if (!row || !row.ID)
            return;
        saveChangesAndProceed(host, row, function () {
            return splitService
                .splitByBlankLines(row.ID, keepFirst)
                .then(function (resp) {
                var d = resp && resp.data ? resp.data : {};
                handleStandardSplitResponse(host, d, 'Split paragraphs:', 'Nothing to split in this note.');
            }, function (err) {
                host.toast("Split failed: ".concat((err && err.message) || 'Error'), 'danger', 5000);
            })
                .finally(function () { return finalizeSplit(host, row, context); });
        });
    }
    function splitByDash(row, context) {
        if (!row || !row.ID)
            return;
        saveChangesAndProceed(host, row, function () {
            return splitService
                .splitByDash(row.ID)
                .then(function (resp) {
                var d = resp && resp.data ? resp.data : {};
                if (d.Result === 'OK') {
                    host.toast("Split dash lines: created ".concat(d.Count || 0, " child note(s)."), 'success', 4500);
                }
                else if (d.Result === 'NONE') {
                    host.toast('No dash-prefixed lines found.', 'info', 3000);
                }
                else {
                    host.toast("Split failed: ".concat(d.Message || d.Result || 'Error'), 'danger', 5000);
                }
            }, function (err) {
                host.toast("Split failed: ".concat((err && err.message) || 'Error'), 'danger', 5000);
            })
                .finally(function () { return finalizeSplit(host, row, context); });
        });
    }
    function splitByBullets(row, context) {
        if (!row || !row.ID)
            return;
        saveChangesAndProceed(host, row, function () {
            try {
                var res = (0, bulletSplit_1.parseBulletStructure)(row.pnBody || '', {
                    parentTaskGroup: row.pnTaskGroup,
                    parentTopicGroup: row.pnTopicGroup,
                    parentTopicDetail: row.pnTopicDetail,
                });
                if (!res.children.length) {
                    host.toast('No bullet lines found.', 'info', 3000);
                    return;
                }
                splitService
                    .splitByBullets(row, res.children)
                    .then(function (out) {
                    host.toast("Bullet split: created ".concat(out.Count, " child note(s)."), 'success', 4500);
                }, function (err) {
                    host.toast("Bullet split failed: ".concat((err && err.message) || err), 'danger', 5000);
                })
                    .finally(function () { return finalizeSplit(host, row, context); });
            }
            catch (e) {
                host.toast("Bullet split error: ".concat((e && e.message) || 'Error'), 'danger', 5000);
            }
        });
    }
    return {
        splitByBlankLines: splitByBlankLines,
        splitByDash: splitByDash,
        splitByBullets: splitByBullets,
    };
}
exports.createRowSplitScopeActions = createRowSplitScopeActions;
function registerRowSplitScopeActions($scope, splitService) {
    var actions = createRowSplitScopeActions($scope, splitService);
    $scope.splitByBlankLines = actions.splitByBlankLines;
    $scope.splitByDash = actions.splitByDash;
    $scope.splitByBullets = actions.splitByBullets;
}
exports.registerRowSplitScopeActions = registerRowSplitScopeActions;
